import React from "react";
import { Entity } from "@common/types/entity";
import { pluralizeWithCount } from "@common/helpers/string";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";

interface Props {
    everythingSelected: boolean;
    selectedEntities: Entity[];
    singleEntityName?: boolean;
    showSelectedIcons: boolean;
}

const MAX_VISIBLE_ENTITIES = 3;

export const AccountsFilterEntityValueDisplay: React.FC<Props> = ({
    everythingSelected,
    selectedEntities,
    singleEntityName,
    showSelectedIcons,
}) => {
    if (everythingSelected) {
        return <>All accounts</>;
    }

    if (selectedEntities.length === 1 && singleEntityName) {
        return (
            <>
                {showSelectedIcons && (
                    <EntityAvatar
                        entity={selectedEntities[0]}
                        size="xs"
                        aria-hidden
                    />
                )}
                <span className="accounts-filter__label__value-name">
                    <BreakableText
                        text={selectedEntities[0].name}
                        className="ml-2"
                    />
                </span>
            </>
        );
    }

    return (
        <>
            {showSelectedIcons && (
                <EntityAvatarGroup
                    entities={selectedEntities}
                    max={MAX_VISIBLE_ENTITIES}
                    size="xs"
                    label={pluralizeWithCount(
                        "Entity",
                        selectedEntities.length,
                    )}
                />
            )}
        </>
    );
};
